import { cloneDeep, forEach } from 'lodash';
import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';

import {
  CHILDRENBOOK,
} from './constants';

function* storeChildrenBook(data = {}, merge = true) {
  yield put({
    type: CHILDRENBOOK.update,
    data,
    merge,
  });
}

function* fetchChildrenBook({
  data,
}) {
  yield* storeChildrenBook(data);
}

function* updateChildrenBook({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    let id = _id;
    if (_id) {
      const {
        childrenBook,
      } = yield select();
      const updatedData = cloneDeep(childrenBook.data);
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'childrenBook',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      updatedData[_id] = data;
      yield* storeChildrenBook(updatedData);
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'childrenBook',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      id = newData._id;
      yield* storeChildrenBook({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess(id));
  } catch (error) {
    yield* storeChildrenBook();
    errorHandler('Thất bại', error);
  }
}

function* removeChildrenBook({
  _id,
  onSuccess,
}) {
  const {
    childrenBook,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'childrenBook',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(childrenBook.data);
    delete newData[_id];
    yield* storeChildrenBook(newData, false);

    successHandler('Thành công', 'Xóa thành công', onSuccess);
  } catch (error) {
    yield* storeChildrenBook();
    errorHandler('Thất bại', error);
  }
}

function* importChildrenBook({
  data = [],
}) {
  const newDocuments = [];
  const updateDocuments = [];
  data.forEach((doc) => {
    if (doc?.createdAt) {
      updateDocuments.push(doc);
    } else {
      newDocuments.push(doc);
    }
  });

  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'childrenBook',
      payload: {
        data: newDocuments,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));

  if (updateDocuments.length) {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.updates({
        collection: 'childrenBook',
        payload: {
          data: updateDocuments,
        },
      }).then(() => resolve(true))
        .catch((err) => reject(err));
    }));
  }

  const {
    childrenBook,
  } = yield select();
  const newDocs = cloneDeep(childrenBook.data);
  forEach(data,
    (obj) => {
      newDocs[obj._id] = obj;
    });
  yield* storeChildrenBook(newDocs);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* childrenBookSaga() {
  yield all([
    yield takeEvery(CHILDRENBOOK.handlers.fetch, fetchChildrenBook),
    yield takeEvery(CHILDRENBOOK.handlers.update, updateChildrenBook),
    yield takeEvery(CHILDRENBOOK.handlers.import, importChildrenBook),
    yield takeEvery(CHILDRENBOOK.handlers.remove, removeChildrenBook),
  ]);
}
